import { React, useEffect } from 'react';
import './App.css';

import Header from './Header';
import Sidebar from './Sidebar';
import Feed from './Feed';
import Widgets from './Widgets';
import Login from './Login';

import { useStateValue } from './StateProvider';

function App() {
  const [{ user }, dispatch] = useStateValue();

  // set the page title
  useEffect(() => {
    document.title = "FacebookClone"
  }, [])

  return (

    // BEM naming convention
    <div className="app">
      {
        !user ? (<Login />)
          : (<>
            <Header />

            <div className="app__body">

              <Sidebar />
              <Feed />
              <Widgets />

            </div>
          </>
          )}
    </div>
    // {/* End of App Layer */}

  );
}

export default App;
